import React from 'react';
import PropTypes from 'prop-types';
import ResponsiveImage from '../ResponsiveImage';
import RichText from '../Prismic/RichText';
import CallToAction from './CallToAction';
import cx from 'classnames';

import './HeroIV.scss';

const HeroIV = props => (
  <section className="hero-iv">
    <div className={cx('hero-iv-image', {
      [`hero-iv-image--${props.heroHeight}`]: props.heroHeight
    })}>
      <ResponsiveImage images={props.backgroundImage} />
    </div>
    <div className={cx('hero-iv-wrapper', {
      [`hero-iv-wrapper--${props.contentVerticalAlign}`]: props.contentVerticalAlign,
      [`hero-iv-wrapper--${props.contentHorizontalAlign}`]: props.contentHorizontalAlign,
      [`hero-iv-wrapper--mobile-${props.contentVerticalAlignMobile}`]: props.contentVerticalAlignMobile,
      'hero-iv-wrapper--mobile': props.isMobile
    })}>
      <div className={cx('hero-iv-container', {
        'hero-iv-container--cta-bottom-locked': props.ctaBottomDesktop === 'true',
        'hero-iv-container--cta-bottom-unlocked': props.ctaBottomDesktop === 'false',
        'hero-iv-container--cta-bottom-mobile-locked': props.ctaBottomMobile === 'true',
        'hero-iv-container--cta-bottom-mobile-unlocked': props.ctaBottomMobile === 'false',
        'hero-iv-container--type-centered': props.contentTypeCentred === 'true' && props.cta && props.ctaLink
      })}>
        <RichText
          className="hero-iv-content"
          fields={props.content}
          color={props.contentColor}
        />
        {props.cta && props.ctaLink && (
          <CallToAction
            href={props.ctaLink}
            cta={props.cta}
            color={props.ctaColor}
            outlined={props.ctaStyle === 'outlined'}
            raised={props.ctaStyle === 'raised'}
          />
        )}
      </div>
    </div>
  </section>
);

HeroIV.propTypes = {
  backgroundImage: PropTypes.shape({
    dimensions: PropTypes.shape({
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired
    }).isRequired,
    alt: PropTypes.string,
    copyright: PropTypes.string,
    url: PropTypes.string.isRequired
  }).isRequired,
  content: PropTypes.array.isRequired,
  contentColor: PropTypes.string,
  cta: PropTypes.string,
  ctaLink: PropTypes.string,
  contentVerticalAlign: PropTypes.string,
  heroHeight: PropTypes.string,
  contentHorizontalAlign: PropTypes.string,
  isDesktop: PropTypes.bool,
  isMobile: PropTypes.bool,
  ctaBottomDesktop: PropTypes.string,
  ctaBottomMobile: PropTypes.string,
  ctaColor: PropTypes.string,
  contentVerticalAlignMobile: PropTypes.string,
  ctaStyle: PropTypes.string,
  contentTypeCentred: PropTypes.string
};

export default HeroIV;



// WEBPACK FOOTER //
// ./src/client/js/view/components/HeroIV/HeroIV.js